import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { omit, snakeCase } from 'lodash';
import displayName from 'component-lib/displayName';

import RadioButtonOn from '../Icons/RadioButtonOn';
import RadioButtonOff from '../Icons/RadioButtonOff';

import TextLabel from './Labels/TextLabel';

import styles from './RadioGroup.scss';

export default class RadioGroup extends Component {
    static displayName = displayName('Widgets/RadioGroup');

    static propTypes = {
        className: PropTypes.string,
        widgetId: PropTypes.string,
        list: PropTypes.array,
        selectedValue: PropTypes.string,
        onSelectedValue: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.bool,
        ]),
    };

    static defaultProps = {
        className: '',
        widgetId: '',
        list: [],
        selectedValue: '',
        onSelectedValue: () => {},
    };

    onSelectButton = id => () => this.props.onSelectedValue &&
          this.props.onSelectedValue(this.props.widgetId, id);

    renderRadioGroup() {
        return this.props.list.map(({ id, value }) => {
            const { selectedValue } = this.props;
            const isSelected = selectedValue === id;

            return (
                <div
                    role="presentation"
                    className={styles['radio-group']}
                    key={id}
                    data-action={`select-${snakeCase(id)}`}
                    onClick={this.onSelectButton(id)}
                >
                    {isSelected &&
                    <RadioButtonOn data-field="selected-radio" className={styles['button-image']} />}

                    {!isSelected && <RadioButtonOff className={styles['button-image']} />}

                    <TextLabel className={styles['radio-label']}>
                        {value}
                    </TextLabel>
                </div>
            );
        });
    }

    render() {
        const widgetProps = omit(this.props, [
            'className',
            'selectedValue',
            'onSelectedValue',
            'list',
            'widgetId',
            'type',
            'styleName',
            'styles',
        ]);

        let className = styles['radio-wrapper'];
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }

        return (
            <div
                data-field={`radio-group-${this.props.widgetId}`}
                {...widgetProps}
                className={className}
            >
                {this.renderRadioGroup(this.props.list)}
            </div>
        );
    }
}
